import React, {useEffect, useRef} from "react";
import {withRouter} from "react-router-dom";
import Breadcrumbs from "./../../../../../ui/Breadcrumbs";
import {connect} from "react-redux";
import {getFullPerson, getDocPerson, getSystemInfo} from "../../store/actions";
import {updatePerson, blockPerson, updatePersonAvatar} from "../../store/send";
import {deletePersons} from "../../store/deleteactions";
import Box from "../../../../../ui/Box";
import {makeStyles} from "@material-ui/core/styles";
import TopBar from "./components/TopBar";
import DeleteConfirmationModal from "../../../../../ui/DeleteConfirmationModal";
import Tabs from "../../../../../ui/Tabs";
import Progress from "../../../../../ui/Progress";
import PersonDrawer from "../../components/PersonDrawer";
import PersonEditForm from "./components/PersonEditForm";
import ProfSkills from "./components/ProfSkills";
import AccountData from "./components/AccountData";
import History from "./components/History";
import {useMediaQuery} from 'react-responsive'
import Documents from "./components/Documents";
import PersonOrganizations from "./components/Organizations";

const useStyles = makeStyles(() => ({
  facilityRoot: {
    display: "flex",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  },
  root: {
    maxWidth: 774,
    minWidth: 400,
    paddingLeft: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  infoForm: {
    marginBottom: 24
  },
  caption: {
    color: '#778899',
    fontSize: 10,
    marginBottom: 16
  },
  fileInput: {
    display: 'none'
  }
}));

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Кадровые ресурсы",
    link: "/work/app/person"
  }
];

const tabitems = [
  {number: 0, caption: "Основная информация"},
  {number: 1, caption: "Документы"},
  {number: 2, caption: "Организации"},
  {number: 3, caption: "Проф. сведения"},
  {number: 4, caption: "Учетные данные"},
  {number: 5, caption: "История"}
];

const initialState = {
  deleteModalOpen: false,
  blockModalOpen: false,
  editablePersonInfo: null,
  editablePersonDocInfo: null,
  isEdited: true,
  isEditable: false
};

const PersonView = ({
                      getFullPerson,
                      getDocPerson,
                      getSystemInfo,
                      requestPersonDelete,
                      isDeletingPerson,
                      updatePerson,
                      isUpdatingPerson,
                      updatedPerson,
                      blockPerson,
                      updatePersonAvatar,
                      personFullInfo,
                      personDocInfo,
                      personSysInfo,
                      match,
                      history
                    }) => {

  const {id} = match.params;
  const classes = useStyles();
  const [state, setStateObject] = React.useState(initialState);
  let editIconRef = useRef();

  const setState = (field, value) => {
    setStateObject({
      ...state,
      [field]: value
    });
  };

  const returnBack = () => history.push("/work/app/person");

  useEffect(() => {
    setState("editablePersonInfo", null);
    setState("editablePersonDocInfo", null);

    getFullPerson(id);
    getDocPerson(id);
    getSystemInfo(id);
  }, [id]);

  useEffect(() => {
    if (personFullInfo) {
      setState("editablePersonInfo", personFullInfo.data);
    }
  }, [personFullInfo]);

  useEffect(() => {
    if (personDocInfo) {
      setState("editablePersonDocInfo", personDocInfo.data);
    }
  }, [personDocInfo]);

  useEffect(() => {
    if (updatedPerson && updatedPerson.success) {
      getFullPerson(id);
      getDocPerson(id);
      getSystemInfo(id);
    }
  }, [updatedPerson]);

  const handleAvatarChangeClick = () => {
    if (editIconRef.current) {
      editIconRef.current.click();
    }
  };

  const handleAvatarLoad = (e) => {
    if (e.target.files.length > 0) {
      updatePersonAvatar(id, e.target.files[0]);
    }
  };

  const isLarge = useMediaQuery({minWidth: 1024});
  const isSmall = useMediaQuery({maxWidth: 774});

  return (

    <div>
      <input ref={editIconRef} className={classes.fileInput}
             onChange={handleAvatarLoad}
             accept="image/*" type="file"/>
      <DeleteConfirmationModal
        modalText="Удалить сотрудника?"
        open={state.deleteModalOpen}
        onConfirm={() => {
          requestPersonDelete(id);
          returnBack();
        }}
        handleClose={() => setState("deleteModalOpen", false)}
      />
      {(personSysInfo && personSysInfo.info && personSysInfo.info.sysRegState < 2) &&
      <DeleteConfirmationModal
        modalText={(personSysInfo.info.sysRegState === 1) ? "Заблокировать сотрудника?" : "Разблокировать сотрудника?"}
        open={state.blockModalOpen}
        onConfirm={() => {
          (personSysInfo.info.sysRegState === 1) ? blockPerson(id, "block") : blockPerson(id, "unblock");
        }}
        buttonCaption={(personSysInfo.info.sysRegState === 1) ? "Заблокировать" : "Разблокировать"}
        handleClose={() => setState("blockModalOpen", false)}
      />}
      <Breadcrumbs items={items}/>
      {(personFullInfo && personSysInfo && personSysInfo.info) ? (
        <div className={classes.facilityRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reload={() => getFullPerson(id)}
                returnBack={returnBack}
                update={() => {
                  setState("isEdited", true);
                  updatePerson(id, state.editablePersonInfo);
                }}
                isUpdating={isUpdatingPerson}
                openDeleteModal={() => setState("deleteModalOpen", true)}
                openBlockModal={() => setState("blockModalOpen", true)}
                isBlocked={personSysInfo.info.sysRegState < 1}
                disabled={!state.isEdited}
                editmode={state.isEditable}
                setEditMode={() => setState("isEditable", true)}
                setViewMode={() => setState("isEditable", false)}
                loadAvatar={handleAvatarChangeClick}
              />
            </div>

            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
                <PersonEditForm editmode={state.isEditable}
                                personInfo={state.editablePersonInfo && state.editablePersonInfo.main ? state.editablePersonInfo.main : personFullInfo.data}
                                personId={personFullInfo.info.id}
                                onFormChange={formState => {
                                  setState("editablePersonInfo", {
                                    ...state.editablePersonInfo, main: formState
                                  });
                                }}/>
              </Box>
              <div>
                <Documents editmode={state.isEditable}
                           personId={personFullInfo.info.id}
                           categoryDocId={3}
                           snilsNumber={state.editablePersonInfo && state.editablePersonInfo.main ? state.editablePersonInfo.main.snils : personFullInfo.data.snils}
                           onSnilsChange={newSnils => {
                             setState("editablePersonInfo", {
                               ...state.editablePersonInfo, main: {
                                 ...state.editablePersonInfo.main,
                                 snils: newSnils
                               }
                             });
                           }}
                           documentInfo={state.editablePersonInfo && state.editablePersonInfo.document ? state.editablePersonInfo.document : (personDocInfo ? personDocInfo.data : {})}
                           onDocumentFormChange={formState => {
                             setState("editablePersonInfo", {
                               ...state.editablePersonInfo, document: formState
                             });
                           }}/>
              </div>
              <Box noMargin>
                <PersonOrganizations personId={personFullInfo.info.id}
                                     editmode={state.isEditable}/>
              </Box>
              <Box noMargin>
                <ProfSkills editmode={state.isEditable}
                            personId={personFullInfo.info.id}
                            editableSkills={(state.editablePersonInfo && state.editablePersonInfo.skillStates) ? state.editablePersonInfo.skillStates : []}
                            editableWorldSkills={(state.editablePersonInfo && state.editablePersonInfo.worldSkills) ? state.editablePersonInfo.worldSkills : []}
                            onSkillsFormChange={formState => {
                              setState("editablePersonInfo", {
                                ...state.editablePersonInfo,
                                worldSkills: formState.worldSkills,
                                skillStates: formState.skillStates
                              });
                            }}
                />
              </Box>
              <Box noMargin>
                <AccountData editmode={state.isEditable}
                             personId={personFullInfo.info.id}
                             systemInfo={personSysInfo}/>
              </Box>
              <Box noMargin>
                <History/>
              </Box>
            </Tabs>

          </div>
          {isLarge &&
          <PersonDrawer personId={id} open hideLink/>}
        </div>
      ) : (
        <Progress/>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  personFullInfo: state.persons.personFullInfo,
  personDocInfo: state.persons.personDocInfo,
  personSysInfo: state.persons.systemInfo,
  isDeletingPerson: state.persons.isDeletingPersons,
  isUpdatingPerson: state.persons.isUpdatingPerson,
  updatedPerson: state.persons.updatedPerson
});

const mapDispatchToProps = dispatch => ({
  getFullPerson: id => dispatch(getFullPerson(id)),
  getDocPerson: id => dispatch(getDocPerson(id)),
  getSystemInfo: id => dispatch(getSystemInfo(id)),
  requestPersonDelete: id => dispatch(deletePersons([id])),
  updatePerson: (id, data) => dispatch(updatePerson(id, data)),
  blockPerson: (id, type) => dispatch(blockPerson(id, type)),
  updatePersonAvatar: (id, file) => dispatch(updatePersonAvatar(id, file))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PersonView));
